<template>
  <div id="app" class="app-container" :class="currentLang == 'en' ? 'en-container' : ''">
    <router-view v-if="isRouterAlive" :currentLang="currentLang" />
    <div class="link-wrapper" v-if="show">
      <SingleCycleDisplay class="cycleDisplayCn" :texts="[$t('message.footer.sloganMsg1'), $t('message.footer.sloganMsg2')]" :buttons="[$t('message.footer.sloganBtnText1'), $t('message.footer.sloganBtnText1')]" :duration="2400" />
      <i class="el-icon-close" @click="show = false"></i>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SingleCycleDisplay from './components/CycleDisplay.vue';

export default {
  name: "App",
  provide() {
    return {
      reloadApp: this.reloadApp,
      changeAppLanguage: this.changeAppLanguage,
      handleContact: this.handleContact,
    };
  },
  components: {
    SingleCycleDisplay,
  },
  data() {
    return {
      isRouterAlive: true,
      currentLang: globalUrl.VUE_LANG,
      // currentLang: 'cn',
      show: true,
    };
  },
  created() {
    this.setLanguage();
    axios({
      method: 'get',
      url: 'https://user.xpirory.cn/xpiory/api/pay/judgeMethod',
    }).then(res => {
      let host = location.host.substring(location.host.lastIndexOf('.'));
      if (host.indexOf(':') < 0) {
        if (res.data.data) {
          if (host != '.net') {
            window.location.href = 'https://www.techbloom.net';
          }
        } else {
          if (host != '.com') {
            window.location.href = 'https://www.techbloomglobal.com';
          }
        }
      }
    });
  },
  methods: {
    handleContact() {
      this.$router.push(`/Contact`);
      window.scrollTo({
        top: 0,
      });
    },
    setRem() {
      // 当前页面屏幕分辨率相对于 1920宽的缩放比例，可根据自己需要修改
      var width = localStorage.documentWidth ? localStorage.documentWidth : document.documentElement.clientWidth;
      const scale = width / 1920;
      // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
      // console.log(16 * Math.min(scale, 2) - 0.17);
      document.documentElement.style.fontSize = 16 * Math.min(scale, 2) + 'px';
    },
    // 设置语言
    setLanguage() {
      if(localStorage.getItem('techbloomLang') != undefined) {
        this.$i18n.locale = localStorage.getItem('techbloomLang');
        this.currentLang = localStorage.getItem('techbloomLang');
      }
      // if (this.$vueCookies.get("lang") == undefined) {
      //   this.$vueCookies.set("lang", globalUrl.VUE_LANG || "en");
      // }
      // if(location.host.substring(location.host.lastIndexOf('.')) == '.cn') { // cn域名默认中文
      //   this.$i18n.locale = 'cn';
      //   this.currentLang = 'cn';
      // } else {
      //   this.$i18n.locale = navigator.language == 'zh-CN' ? 'cn' : 'en';
      //   this.currentLang = navigator.language == 'zh-CN' ? 'cn' : 'en';
      // }
    },
    // 切换语言
    changeAppLanguage(lang) {
      // if(lang == 'en') {
      //   window.location.href = 'https://www.techbloomglobal.com';
      // }
      
      // localStorage.setItem("lang", lang);
      this.$i18n.locale = lang;
      this.currentLang = lang;
      this.reloadApp();
    },
    reloadApp() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
  mounted() {
    // this.setRem();
    this.$store.commit('CHANGEWidth', document.documentElement.clientWidth);
    window.addEventListener('resize', () => {
      // 你的逻辑代码
      this.$store.commit('CHANGEWidth', document.documentElement.clientWidth);
    });
  },
};
</script>

<style lang="scss">
/*页面开始*/
html,
body,
#app {
  height: 100%;
  width: 100%;
}
.link-wrapper {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url('./assets/images/footer/background.jpg') center center no-repeat;;
  z-index: 9999;
  i {
    color: #fff;
    font-size: 20px;
    position: fixed;
    right: 95px;
    bottom: 17px;
    cursor: pointer;
  }
  .cycleDisplayCn {
    font-size: 16px;
    color: #fff;
    
    .el-button {
      margin-left: 95px;
    }
  }
}
</style>
